/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-len */
import React from 'react';
import { Box, Center, VStack } from 'native-base';

import { useI18n, useSpringBigStore } from '@springbig/shared';

import QrCode from '~/shared/QrCode';
import Section from '~/shared/Section';
import ReferSocialMedia from './components/ReferSocialMedia';
import ReferCopyLink from './components/ReferCopyLink';
import ReferRewards from './components/ReferRewards';
import { useGeneralStyles, useReferStyles } from '~/shared/styles';
import { useToast } from '~/hooks/toast';
import { useCopyToClipboard } from 'usehooks-ts';
import { useAuthorization } from '~/hooks/auth';
import Loading from '~/shared/Loading';
import Pressable from '~/shared/Pressable';
import { Caption } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';

export const ReferScreen = () => {

    const { member } = useSpringBigStore();
    const { t } = useI18n();
    const { qr_code_background, qr_code_color, icon } = useReferStyles();
    const { successToast } = useToast();
    const [value, copy] = useCopyToClipboard();
    const gStyle = useGeneralStyles();

    const { isLoadingAuth } = useAuthorization();

    const handleClipboard = (target?: string) => {

        copy(member?.referrals?.link);
        successToast(t('refer.link_copied'));

        if (target && /(https?:\/\/|www\.)/.test(target)) {
            window.open(target, '_blank');
        }
    };

    if (isLoadingAuth) {
        return <Loading isLoading={isLoadingAuth} />;
    }

    return (
        <Section flex={1} w={'100%'} overflowY={'auto'}>
            <Center mb={4}>
                <Pressable
                    testID='refer-share-icon'
                    py={6}
                    w={'100%'}
                    mb={5}
                    flexDirection='row'
                    alignItems={'center'}
                    onPress={() => handleClipboard}
                >
                    <Caption
                        text="refer.title"
                        my={0}
                        mr={0}
                        pl={4}
                        pr={1}
                    />
                    <SpIcon
                        icon={faShareAlt}
                        color={icon}
                    />
                </Pressable>
                <Box w={'100%'} alignItems='center' pb={5}>
                    <Box
                        p={4}
                        bg={qr_code_background}
                        borderRadius={'md'}
                        w={'48'}
                        h={'48'}
                    >
                        <QrCode
                            color={qr_code_color}
                            size={170}
                            value={member && member.referrals?.link || 'www.google.com'}
                        />
                    </Box>
                </Box>
                <VStack space={4} my={4}>
                    {member?.referrals?.referrer_offer_name && (
                        <Box bg={gStyle.section_background} p={4}>
                            <ReferRewards member={member} />
                        </Box>
                    )}
                    <Box bg={gStyle.section_background} p={4}>
                        <ReferCopyLink member={member} copyToClipboard={handleClipboard} link={t('refer.copy_link')} />
                    </Box>
                    <Box bg={gStyle.section_background} p={4}>
                        <ReferSocialMedia copyToClipboard={handleClipboard} />
                    </Box>
                </VStack>
            </Center>
        </Section>
    );
};

export default ReferScreen;
